import React from 'react';
import styles from './PrintTasksRow.module.scss';
import { TaskRowViewModel } from '../utils/TaskPrintMapper';
import PrintPetInfo from '../PrintPetInfo/PrintPetInfo';
import { TasksRenderer } from './TasksRenderer/TasksRenderer';

interface PrintTasksRowProps {
    row: TaskRowViewModel;
}

export const PrintTasksRow: React.FC<PrintTasksRowProps> = ({ row }) => {
    return (
        <tr className={styles.row}>
            <td className={styles.colPet}>
                <PrintPetInfo
                    petName={row.petName}
                    petBreed={row.petBreed}
                    petType={row.petType}
                    hasMedicalConditions={row.hasMedicalConditions}
                    hasNegativeTags={row.hasNegativeTags}
                />
            </td>
            <td className={styles.colTask}>{TasksRenderer[row.type](row)}</td>
            <td className={styles.colNotes}>{row.notesLabel}</td>
            <td className={styles.colTime} />
            <td className={styles.colStaff} />
        </tr>
    );
};

export default PrintTasksRow;
